<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name" [disabled]="ngxDisabled" 
    [(ngModel)]="stationSelected" placeholder="Estación" (select)="changeStation($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrada
    </ng-template>

</ngx-select>